import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
  Button,
  InputAdornment,
  TablePagination,
} from "@material-ui/core";
import AttachmentsCover from "../../../components/Attachments/AttachmentsCover";
import WarningBox from "../Components/WarningBox";
import { Download } from "@material-ui/icons";

// import DocViewer,  { PDFRenderer, PNGRenderer  ,DocViewerRenderers } from "react-doc-viewer";
// import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";

// import FormControlLabel from "@mui/material/FormControlLabel";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import { makeStyles } from "@material-ui/styles";
import { Checkbox } from "@material-ui/core";
import VendorTaxTable from "../NewInvoice/Tables/Vendor_Tax_Detail";
import CommentHistory from "../NewInvoice/Tables/CommentHistory";
import ConfirmationModal from "../../../components/ConfirmModal/ConfirmationModal.js";
import {
  clearState,
  getCommentsByInvoiceId,
  getInvoiceByInvoiceIdAndRoleId,
  getVendorByPO,
  updateInvoiceByTaxTeam,
  uploadAdditioalDocumentFile,
  uploadFile,
  vendorTaxDetailForCnic,
  getAllInvoiceDetailByInvoiceId,
  getBatchInvoiceDetails,
  changeInvoiceStatus
} from "../actions";

import InvoiceGuideLine from "../NewInvoice/InvoiceGuidLines/InvoiceGuideLine.js";
import CustomSnackbar from "../../../CustomSnackbar";
import InvoiceCheckboxes from "../Components/InvoiceDetails/InvoiceCheckboxes";
import InvoiceRadioButtons from "../Components/InvoiceDetails/InvoiceRadiobuttons";
import InvoiceTextField from "../Components/InvoiceDetails/InvoiceTextFields";
import InvoiceDetailTextField from "../Components/InvoiceDetails/InvoiceDetailTextFields";
import TaxDetailTextField from "../Components/TaxDetails/TaxDetailTextField";
import TaxDetail from "../Components/TaxDetails/TaxDetails";
import TaxTable from "../NewInvoice/Tables/Tax_Table";

import { dashboardStyle } from "../Components/InvoiceDetails/style";
import { useNavigate } from "react-router-dom";
import { ArrowBack, Delete } from "@material-ui/icons";
import VisibilityRoundedIcon from "@material-ui/icons/VisibilityRounded";
import downloadAttachments from "../../../Functions/downloadAttachments";
import Heading from "../../../StyledComponents/Heading/Heading";

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const useStyles = makeStyles(dashboardStyle);

const TaxTeamDetail = () => {
  const classes = useStyles();

  const navigate = useNavigate();
  const invoiceId = getParameterByName("invoiceId");
  const roleId = getParameterByName("roleId");
  const roleName = getParameterByName("roleName");
  const vendorCode = getParameterByName("vendorCode");
  const edit = getParameterByName("edit");
  const status = getParameterByName("status");
  const invoicePayload = {
    Invoice_id: invoiceId,
    Vendor_Code: vendorCode,
  };

  const role = {
    roleId: roleId,
    roleName: roleName,
  };
  const [selectedRole, setSelectedRole] = useState(
    role ? { role: role?.roleName } : ""
  );

  const [poBasedState, setPoBasedState] = useState("PO");
  // const [physicalOrEInvoice, setPhysicalOrEInvoice] = useState("Physical");
  const [attachInvoiceLoading, setAttachInvoiceLoading] = useState(false);
  const [attachmentFile_UI, setAttchmentFile_UI] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [statusForPayload, setStatusForPayload] = useState("");
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [openInvoiceGuideLine, setOpenInvoiceGuideLine] = useState(false);
  // const [isLoading, setIsLoading] = useState(true);

  const [openWarningBox, setOpenWarningBox] = useState(false);
  const [currentStateForDeleteion, setCurrentStateForDeleteion] = useState("");

  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);

  const invoice_attachmentRef = useRef(null);
  const additionalAttachmentRef = useRef(null);

  const [formState, setFormState] = useState({
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,

    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,

    invoice_Id: "",
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: "",
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: [], // paths
    comments: "",
    additionalDocIds_array: [], // additional documents in array
    invoice_Accounts_list: [
      {
        glAccount: "",
        costCenter: "",
        costCenterOwner: "",
        costCenterOwnerName: "",
        horizonId: "",
        vendorCode: "",
        amount: 0,
        profitCenter: "",
        department: "",
      },
    ],

    invoicePORef_List: [
      {
        poItem: "", //  item #
        poNumber: "", // poNumber
        refDoc: "", // GRN No
        quantity: "", // GRN quantity
        val_Loccur: "", // GRN amount
        invoicE_QTY: "", //  consumed quantity
        invoicE_VAL: 0, // consumed Amount
        inpuT_QTY: "", //  invoice QTY
        inpuT_VAL: "", //  Invoice amount
        currency: "", // currency
      },
    ],

    Expense_Accounts_list: [
      // Invoice_Accounts_list for back-end
      {
        expenseDate: "",
        description: "",
        amount: 0,
        glAccount: "",
        costCenter: "",
        fixedAsset: "",
        tType: "",
        profitCenter: "",
        costCenterOwner: "",
        costCenterOwnerName: "",
        horizonId: "",
        vendorCode: "",
        department: "",
      },
    ],
    Invoice_Clearingvendor_list: [
      {
        vendorCode: "",
        VendorName: "",
        amount: "",
      },
    ],
    PageNo: 1,
    RowsOfPage: 25,
    verified: false,
  });

  const [taxFormState, setTaxFormState] = useState({
    invoice_Id: invoicePayload?.Invoice_id || "",
    cnic: "",
    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: false,
    xmlTaxDetail: "",
    comments: "",
    aditional_Comments: "",
    actionPerform: "",
    commentBy: "",
    status: "",
    additionalDocIds: [],
    invoice_No: "",
    vendor_tax_detail: [],
    isReturn : false,
    
    taxCard_List: [
      // invoice_TaxDetails earlier
      {
        invoice_Id: invoicePayload?.Invoice_id || 0,
        category: "",
        purchaseType: "",
        supplierJurisdiction: "",
        supplierType: "",
        status: "",
        fillingStatus: "",
        goodsNature: "",
        taxType: "",
        taxCode: "",
        amount: 0,
      },
    ],
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const taxChangeHandler = (e) => {
    const { name, value } = e.target;
    setTaxFormState((taxFormState) => ({
      ...taxFormState,
      [name]: value,
    }));
  };
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));

    if (name === "pO_No") {
      getVendorByPO(value, "vendor_Code", setFormState);
      // if passing PONumber
      // getPODetails(value, "",setFormState)
      // form dummy data
      // getPODetails(setFormState)
    }
  };
  const deleteAttachmentFunc = () => {
    let ss = currentStateForDeleteion?.ss;
    let f = currentStateForDeleteion?.f;

    const files = taxFormState.additionalDocIds.filter((x, i) => {
      const n = x.split("\\");
      const nn = n[n.length - 1];
      return nn !== ss;
    });
    setTaxFormState((taxFormState) => ({
      ...taxFormState,
      additionalDocIds: files,
    }));

    //removing data from attachemt list for preview
    let filtered_attachs = attachmentURLList?.filter((x) => x !== f);
    setAttachmentURLList(filtered_attachs);
    setAttachmentURL(filtered_attachs[filtered_attachs.length - 1]);
    setOpenWarningBox(false);
  };

  const showVendorAndPO_NumberForImport = () => {
    let show = selectedRole?.role === "Import" ? true : false;
    if (selectedRole?.role === "Import" && formState.demandType === "Deposit") {
      show = false;
    }

    return show;
  };

  const showVendorCodeForImport = () => {
    let show = selectedRole?.role === "Import" ? true : false;
    if (
      selectedRole?.role === "Import" &&
      formState.demandType === "Spare Parts"
    ) {
      show = false;
    }
    if (
      selectedRole?.role === "Import" &&
      formState.demandType === "Material"
    ) {
      show = false;
    }
    if (selectedRole?.role === "Import" && formState.demandType === "Samples") {
      show = false;
    }
    return show;
  };
  // >>>___FileAttachment____
  const [attachmentURL, setAttachmentURL] = useState("");
  const [attachmentURLList, setAttachmentURLList] = useState([]);

  const showAttachmentsHandler = (attachment_URL) => {
    setAttachmentURL(attachment_URL);
  };

  // to upload the file and get path.
  const poBasedHandler = (e) => {
    setPoBasedState(e.target.value);
    clearState(setFormState);
  };
const [Post ,setPost] = useState(true)
const confirmedForInvoiceCreation = () => {
  setErrorMessage("");
  if (taxFormState?.isReturn) {
    changeInvoiceStatus(
      formState.invoice_Id,
      statusForPayload,
      setConfirmationModal,
      setAttachInvoiceLoading,
      setSuccessMessage,
      setErrorMessage,
      navigate,
      taxFormState.comments,
      taxFormState.aditional_Comments,
      setPost
    );
    setConfirmationModal(false);
  }
};
  const submitHandler = (e) => {
    e.preventDefault();
    setConfirmationModal(true);
    // updateInvoiceByTaxTeam(
    //   taxFormState,
    //   setTaxFormState,
    //   setErrorMessage,
    //   setSuccessMessage,
    //   setAttachInvoiceLoading,
    //   navigate
    // );
  };
  const handleChangePage = (event, newPage) => {
    setFormState((formState) => ({
      ...formState,
      PageNo: newPage,
    }));
  };

  const handleChangeRowsPerPage = (event) => {
    // setRowsPerPage(parseInt(event.target.value, 10));

    setFormState((formState) => ({
      ...formState,
      RowsOfPage: event.target.value,
    }));
    // setPage(0);
  };
  const [dataLoading, setDataLoading] = useState(0);
  useEffect(() => {
    if (invoicePayload && role) {
      vendorTaxDetailForCnic(setTaxFormState, invoicePayload?.Vendor_Code);
      // getInvoiceByInvoiceIdAndRoleId(
      //   invoicePayload,
      //   role,
      //   setFormState,
      //   setPoBasedState
      // );
      getBatchInvoiceDetails(
        setTaxFormState,
        () => {},
        () => {},
        invoicePayload,
        role,
        setFormState,
        setDataLoading,
        setPoBasedState
      );
      // getInvoiceByInvoiceIdAndRoleId(
      //   setIsLoading,
      //   invoicePayload,
      //   role,
      //   setFormState
      // );
      getCommentsByInvoiceId(
        setCommentsList,
        setCommentsLoading,
        invoicePayload?.Invoice_id
      );

      //   vendorTaxDetailForCnic(
      //     setTaxFormState,
      //     invoicePayload?.Vendor_Code,
      //     setCount
      //   );
    }
  }, []);
  // useEffect(() => {
  //   getAllInvoiceDetailByInvoiceId(
  //     () => {},
  //     () => {},
  //     invoicePayload?.Invoice_id,
  //     setTaxFormState,
  //     () => {},
  //     "APS",
  //     () => {}
  //     // taxFormState,
  //     // invoicePayload?.Vendor_Code,
  //   );
  // }, []);

  // import this
  useEffect(() => {
    //
    // formState?.additionalDocIds);
    let filterd_data = [];
    if (formState?.additionalDocIds?.length > 0) {
      filterd_data = formState.additionalDocIds.filter((e) => Number(e) !== 0);
      // setAttachmentURLList((pre) => ([...pre, formState?.invoice_attachment,
      // ...filterd_data]))
    }

    setAttachmentURLList((pre) => [
      formState?.invoice_attachment,
      ...filterd_data,
    ]);
    setAttachmentURL(formState?.invoice_attachment);
  }, [formState?.invoice_attachment, formState?.additionalDocIds]);

  useEffect(() => {
    if (taxFormState?.additionalDocIds?.length > 0) {
      setAttachmentURLList((pre) => [
        ...pre,
        taxFormState?.additionalDocIds[
          taxFormState?.additionalDocIds.length - 1
        ],
      ]);
    }
    // if (taxFormState?.additionalDocIds?.length > 1) {
    //   setAttachmentURLList((pre) => ([...pre, taxFormState?.additionalDocIds[(taxFormState?.additionalDocIds.length - 1)]]))
    // } else {
    //   setAttachmentURLList((pre) => ([...pre, ...taxFormState?.additionalDocIds]))
    // }
  }, [taxFormState?.additionalDocIds]);

  return (
    <Card>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={dataLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <CardHeader color="primary" text>
        <CardText
          style={{
            padding: "0px 27px",
            backgroundColor: "#031C30",
            color: "white",
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid item xs={2} sm={3} md={3} lg={6}>
              <h1 style={{ fontSize: "24px" }}>Tax Check</h1>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <IconButton
                variant="contained"
                style={{ float: "right", marginTop: "1.5%" }}
                onClick={() => navigate("/home")}
              >
                <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
              </IconButton>
            </Grid>
          </Grid>
        </CardText>
      </CardHeader>
      <CardBody>
        {/* <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={attachInvoiceLoading}
        >
          <CircularProgress color="inherit" />
      </Backdrop>*/}

        <form onSubmit={submitHandler}>
          {/*  {formState.invoice_No && (
            <TaxDetail
            formState={taxFormState}
            setFormState={setTaxFormState}
            invoice_Amount={formState.invoice_Amount}
            edit={edit}
          />
          
        )}*/}
          {formState.invoice_No && (
            <TaxDetailTextField
              formState={taxFormState}
              setFormState={setTaxFormState}
              invoice_Amount={formState.invoice_Amount}
              edit={edit}
            />
          )}
          {formState.invoice_No && (
            <TaxTable
              formState={taxFormState}
              setFormState={setTaxFormState}
              invoice_Amount={formState.invoice_Amount}
              invoicePayload={invoicePayload}
              show={true}
              edit={edit}
              setTaxErrorMsg={() => {}}
              taxErrorMsg={() => {}}
            />
          )}
          {formState.invoice_No && (
            <VendorTaxTable
              formState={taxFormState}
              setFormState={setTaxFormState}
            />
          )}
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <CommentHistory
              commentsList={commentsList}
              commentsLoading={commentsLoading}
            />
          </Grid>
        

          {/* <TablePagination
          rowsPerPageOptions={[25, 50, 100]}
          component="div"
          count={count}
          rowsPerPage={formState.RowsOfPage}
          page={parseInt(formState.PageNo) - 1}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        */}
          {/* <Grid item xs={12} sm={12} md={3} lg={3} mt={2}>
            <Typography>
              Additional Document <span className={classes.asterisk}>*</span>
            </Typography>
            <TextField
              fullWidth
              size="small"
              sx={{
                // width: "70%",
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <input
                      ref={additionalAttachmentRef}
                      type="file"
                      name="additionalDocIds"
                      accept="application/pdf, image/png , image/jpg , image/jpeg "
                      onChange={(e) =>
                        uploadAdditioalDocumentFile(
                          e,
                          setTaxFormState,
                          setAttachInvoiceLoading,
                          "additionalDocIds",
                          additionalAttachmentRef
                        )
                      }
                     disabled={edit == "false" ? true : false}

                      style={{ width: "209px" }}
                    />
                  </InputAdornment>
                ),
              }}
            />

            {taxFormState?.additionalDocIds?.length > 0 &&
              taxFormState?.additionalDocIds?.map((f, index) => {
                const s = f.split("\\");
                const ss = s[s.length - 1];
                return (
                  <div>
                    {f !== "" ? (
                      <>
                        <Delete
                          color="danger"
                          fontSize="small"
                          onClick={() => {
                            setOpenWarningBox(true);

                            setCurrentStateForDeleteion({
                              ss,
                              f,
                            });
                          }}
                        />
                        <Download
                          onClick={() => {
                            downloadAttachments(f);
                          }}
                        />{" "}
                        <IconButton
                          size="small"
                          onClick={() => {
                            setAttachmentURL(f);
                          }}
                        >
                          <a style={{ fontSize: "14px", textDecoration: 'none', color:"black"}}
                          href={`${process.env.REACT_APP_API_URL}/Uploads/${ss}`}
                          target="_blank"
                          >
                          {ss}
                          </a>
                        </IconButton>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                );
              })}

           
          </Grid> */}

          {/* <Grid item xs={12} sm={12} md={3} lg={12}>
            <Typography>
              comments
              <span className={classes.asterisk}>*</span>
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={2}
              maxRows={4}
              // size="small"
              sx={{
                // width: "70%",
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
              name="comments"
              value={taxFormState.comments}
              onChange={taxChangeHandler}
            />
          </Grid> */}

          {/* <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={12}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "10px",
            }}
          >
            <Button
              style={{ margin: "2px", color: "white" }}
              variant="contained"
              color="danger"
              onClick={() => navigate("/home")}
            >
              CANCEL
            </Button>
            <Button
              style={{ margin: "2px" }}
              variant="contained"
              color="secondary"
              type="submit"
            >
              PROCEED
            </Button>
          </Grid> */}

          <Typography
            variant="h5"
            component="h2"
            style={{ paddingLeft: "7px" }}
          >
            <Heading title="Invoice Detail" />
          </Typography>
          {/* Check boxes */}
          <InvoiceCheckboxes
            formState={formState}
            setFormState={setFormState}
            selectedRole="TaxTeam"
            disabled={true}
          />

          {/* Radio Buttons */}
          <InvoiceRadioButtons
            formState={formState}
            setFormState={setFormState}
            selectedRole="TaxTeam"
            // physicalOrEInvoice={physicalOrEInvoice}
            poBasedState={poBasedState}
          />
          <Grid container style={{ padding: "0px 5px 0px 6px" }}>
            <Grid item xs={12} sm={12} md={12} lg={6}>
             
              <InvoiceDetailTextField
                newFormState={formState}
                setNewFormState={setFormState}
                selectedRole="TaxTeam"
                disabled={true}
                poBasedState={poBasedState}
                showVendorAndPO_NumberForImport={
                  showVendorAndPO_NumberForImport
                }
                showVendorCodeForImport={showVendorCodeForImport}
                invoice_attachmentRef={invoice_attachmentRef}
                additionalAttachmentRef={additionalAttachmentRef}
                setAttachInvoiceLoading={setAttachInvoiceLoading}
                // setAttchmentFile_UI={setAttchmentFile_UI}
                // attachmentFile_UI={attachmentFile_UI}
                // physicalOrEInvoice={physicalOrEInvoice}
                changeHandler={changeHandler}
                alignForAttachment={true}
                showAttachmentsHandler={showAttachmentsHandler}
                attachmentURLList={attachmentURLList}
                setAttachmentURLList={setAttachmentURLList}
                setAttachmentURL={setAttachmentURL}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6}>
              <Typography
                variant="h5"
                component="h2"
                style={{ paddingLeft: "7px" }}
              >
                <Heading title="Attachment Preview" />
              </Typography>
              <AttachmentsCover
                attachmentURLList={attachmentURLList}
                setAttachmentURLList={setAttachmentURLList}
                attachmentURL={attachmentURL}
                setAttachmentURL={setAttachmentURL}
              />
            
            </Grid>
       
          </Grid>
          {((status === "SendToDeptCoordinator" ||
            status === "SendToIP") && Post) && (
            <>
              <Grid item xs={12} sm={12} md={6} lg={6} mt={2}>
                <Typography style={{ color: "black" }}>
                  Comments:
                  {/* <span className={classes.asterisk}>*</span> */}
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  name="comments"
                  value={taxFormState.comments}
                  onChange={taxChangeHandler}
                  maxRows={4}
                  // size="small"
                  sx={{
                    // width: "70%",
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  required={taxFormState?.isReturn}
                />
                <Button
                  style={{
                    margin: "2px",
                    marginTop: "6px",
                    color: "white",
                    fontWeight: "700",
                  }}
                  variant="contained"
                  color="secondary"
                  type="submit"
                  // id="saveAsDraft"
                  onClick={() => {
                    setTaxFormState((taxFormState) => ({
                      ...taxFormState,
                      isReturn: true,
                      isProceed: false,
                    }));
                    setConfirmationMessage(
                      "Are you sure to Recall  this invoice "
                    );

                     setStatusForPayload("SendToTaxTeam"); 
                    // setConfirmationModal(true);
                  }}
                >
                  Recall
                </Button>
              </Grid>
            </>
          )}
        </form>
      </CardBody>
      {confirmationModal && (
        <ConfirmationModal
          open={confirmationModal}
          close={() => setConfirmationModal(false)}
          message={confirmationMessage}
          submit={confirmedForInvoiceCreation}
          loading={attachInvoiceLoading}
        />
      )}
      {openInvoiceGuideLine && (
        <InvoiceGuideLine
          open={openInvoiceGuideLine}
          close={setOpenInvoiceGuideLine}
        />
      )}
      {successMessage && (
        <CustomSnackbar
          open={successMessage !== ""}
          message={successMessage}
          handleClose={() => setSuccessMessage("")}
          variant="success"
        />
      )}
      {errorMessage && (
        <CustomSnackbar
          open={errorMessage !== ""}
          message={errorMessage}
          handleClose={() => setErrorMessage("")}
          variant="error"
        />
      )}
      {openWarningBox && (
        <WarningBox
          open={openWarningBox}
          close={() => setOpenWarningBox(false)}
          submit={deleteAttachmentFunc}
          message="Are you sure to delete attachment"
        />
      )}
    </Card>
  );
};

export default TaxTeamDetail;
